import React from 'react';
import enhance from './enhance';
import ModelSearch from '../ModelSearch';
import styles from './styles.module.scss';
import searchSrc from './btn-search.svg';
import closeSrc from './btn-x.svg';

export const ModelTemplateHeader = ({
  model,
  showInReview,
  showSubmitted,
  inReviewView,
  tabStyle,
  remainingQuota,
  modelSubmittedTotalWorkingStateCalculated,
  reviewLabel,
  submittedLabel,
  searchView,
  showSearch,
  closeSearch,
  searchOptions,
  searchMenuVisibility,
  menuOpen,
  openDropdown,
}) =>
  searchView ? (
    <ModelSearch
      model={model}
      closeSearch={closeSearch}
      closeSrc={closeSrc}
      searchSrc={searchSrc}
      searchOptions={searchOptions}
      searchMenuVisibility={searchMenuVisibility}
      menuOpen={menuOpen}
      openDropdown={openDropdown}
    />
  ) : (
    <div className={styles.modelTabs}>
      <button className={tabStyle.reviewTabStyle} onClick={showInReview}>
        {reviewLabel} ({remainingQuota})
      </button>
      <button className={tabStyle.submittedTabStyle} onClick={showSubmitted}>
        {submittedLabel} ({modelSubmittedTotalWorkingStateCalculated})
      </button>
      {inReviewView && (
        <span className={styles.searchIcon} onClick={showSearch}>
          <img src={searchSrc} alt="" />
        </span>
      )}
    </div>
  );

export default enhance(ModelTemplateHeader);
